<template>
    <div @click="copyToClipboard" class="cpn-copy-holder copyToClipboard">
        <span v-if="couponText" class="coupon-text">  {{ couponText ? value : '' }} </span>
        <i class="btn ecom-copy prz-copy" />
        <span v-if="btnText" class="btn-text">  {{ btnText }} </span>
        <transition name="fade-copy">
            <div v-if="showCopied" class="copied">{{ kStrings.kCOPIED }} </div>
        </transition>
    </div>
</template>
<script>
import copyToClipboard from '@/Utilities/copyToClipboard';
    export default {
        name: "CopyToClipboard",
        components: {},
        props: {
            value: {
                type: String,
                default: ''
            },
            btnText: { // in case of being a button 
                type: String,
                default: ''
            },
            couponText: {
                type: Boolean,
                default: false
            },
            kStrings: {
                type: Object, 
                default: {}
            },
        },
        data: function () {
            return {
                copied: {
                    type:Boolean,
                    default: false,
                }
            };
        },
        computed: {
            showCopied(){
                return this.copied === true;
            },
        },
        methods:{
            copyToClipboard(){
                const copy = copyToClipboard.copy(this.value);
                if(copy){
                    this.copied = true;
                }
                else{
                    this.copied = false;
                }
                setTimeout(function () { this.copied = false; }.bind(this), 2000)
                this.$emit('input', this.value);
            }
        },
        mounted() {  
        },
    };
</script>

<style lang="scss">
    .fade-copy-enter-active, .fade-copy-leave-active {
        transition: opacity 300ms;
    }
    
    .fade-copy-enter, .fade-copy-leave-to {
        opacity: 0;
    }

</style>

